const ibValues = {
  maxContentWidth: '1440px',
  headerHeight: '80px'
};
export default ibValues;
